export const ATTACHMENT_ERRORS = {
    saveMutationErrorMessage: 'The save attachments mutation failed with an error in the response!',
    saveServerErrorMessage: 'The save attachments operation failed with a server error!',

    deleteMutationErrorMessage: 'The delete attachments mutation failed with an error in the response!',
    deleteServerErrorMessage: 'The delete attachments operation failed with a server error!'
} as const;

export class SaveAttachmentMutationError extends Error {
    constructor(message?: string) {
        super(message || ATTACHMENT_ERRORS.saveMutationErrorMessage);
        this.name = 'SaveAttachmentMutationError';
    }
}

export class SaveAttachmentServerError extends Error {
    constructor(message?: string) {
        super(message || ATTACHMENT_ERRORS.saveServerErrorMessage);
        this.name = 'SaveAttachmentServerError';
    }
}

export class DeleteAttachmentMutationError extends Error {
    constructor(message?: string) {
        super(message || ATTACHMENT_ERRORS.deleteMutationErrorMessage);
        this.name = 'DeleteAttachmentMutationError';
    }
}

export class DeleteAttachmentServerError extends Error {
    constructor(message?: string) {
        super(message || ATTACHMENT_ERRORS.deleteServerErrorMessage);
        this.name = 'DeleteAttachmentServerError';
    }
}
